import type { AnnotationLabelT, RangeSpanT } from '../../../common/types/types';
import { ANNOTATION_TYPE } from '../../labelling/constants';
import type { TimeDisplayMode } from '../../types';
import type { SidePanelImageAnnotation } from '../components/side-panel/side-panel';
import { getTagsForAnnotation } from '../components/side-panel/utils';
import type { MetadataPayload } from '../studio-store/types';
import { resolveAnnotationType } from './resolve-annotation-type';
export const DEFAULT_ANNOTATION_LABEL_STYLE: AnnotationLabelT['style'] = {
  strokeColor: '#000000',
  fillColor: '#000000',
  fillOpacity: 0.5,
  strokeWidth: 2
};
export function buildAnnotationLabel(metadata: MetadataPayload, annotationIdToLabelMap: Map<string, AnnotationLabelT>): AnnotationLabelT {
  return annotationIdToLabelMap.get(metadata.annotationId) ?? {
    title: metadata.labelId,
    style: DEFAULT_ANNOTATION_LABEL_STYLE
  };
}
type BuildSidePanelAnnotationParamsT = {
  annotationId: string;
  metadata: MetadataPayload;
  annotationLabel: AnnotationLabelT;
  hidden: boolean;
  locked: boolean;
  annotationSpan: RangeSpanT[] | undefined;
  timeDisplayMode: TimeDisplayMode;
  frameRate: number | null | undefined;
  maxFrames: number;
};
export function buildSidePanelAnnotation({
  annotationId,
  metadata,
  annotationLabel,
  hidden,
  locked,
  annotationSpan,
  timeDisplayMode,
  frameRate,
  maxFrames
}: BuildSidePanelAnnotationParamsT): SidePanelImageAnnotation {
  const partialAnnotation = {
    id: annotationId,
    annotationType: resolveAnnotationType(annotationLabel, metadata.annotationType),
    annotationLabel,
    hidden,
    locked,
    metadata: {
      answers: metadata.answers,
      consensusInfo: metadata.consensusInfo
    }
  };
  const tags = getTagsForAnnotation({
    annotation: partialAnnotation,
    annotationSpan,
    timeDisplayMode,
    frameRate,
    maxFrames
  });
  return {
    ...partialAnnotation,
    tags,
    canCopyObjectInstance: partialAnnotation.annotationType !== ANNOTATION_TYPE.FRAME_CLASSIFICATION && partialAnnotation.annotationType !== ANNOTATION_TYPE.SEGMENTATION
  };
}